import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { promiseLandAction } from "../../actions/promiseLandAction";
import updownArrows from "../../assets/images/up_down_arrows.svg";
import { showAlert } from "../common/functions";
import PromiseLandService from "../../services/api/promiseLandService";
import Select from "react-select";
import OrderFilter from "../musics/orderFilter";

interface PromiseLandProps {
	dispatch: Dispatch<any>;
	promiseLandData: any;
}

const PromiseLandList: React.SFC<PromiseLandProps> = ({
	dispatch,
	promiseLandData,
}) => {
	const history = useHistory();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchText, setSearch] = useState<string>("");
	const [selectedId, setSelectedId] = useState(-1);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");
	const [columnSort, setColumnSort] = useState<any>(null);
	const [selectedStatus, setSelectedStatus] = useState<any>(null);
	const [categoryList, setCategoryList] = useState<any[]>([]);
	const [rangeFilter, setRangeFilter] = useState<any>(null);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			categoryId: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
		};
		setShowModal(true);
		dispatch(promiseLandAction.promiseLandGetByFilter(body));
	}, [debouncedSearch, columnSort]);

	React.useEffect(() => {
		const fetchDropdown = async () => {
			const dropdownList: any = await PromiseLandService.getCategoriesApi();
			setCategoryList(dropdownList?.activeCategories);
		};
		fetchDropdown();
	}, []);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleLoadDeleteModal = () => {
		dispatch(promiseLandAction.promiseLandDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	if (
		promiseLandData &&
		!promiseLandData.isLoading &&
		promiseLandData.isListSuccess
	) {
		promiseLandData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (
		selectedId >= 0 &&
		promiseLandData.isSuccess &&
		promiseLandData.isDeleteCompleted &&
		!promiseLandData.isError
	) {
		showAlert(promiseLandData.status, false);
		promiseLandData.isSuccess = false;
		promiseLandData.isDeleteCompleted = false;
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber:
				promiseLandData?.items?.contextualMedias?.length === 1
					? currentPage - 1
					: currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			categoryId: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
		};
		setShowModal(true);
		dispatch(promiseLandAction.promiseLandGetByFilter(body));
		setCurrentPage(
			promiseLandData?.items?.contextualMedias?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}
	if (!promiseLandData.isSuccess && promiseLandData.isError) {
		if (promiseLandData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(promiseLandData.status, true);
		}
		promiseLandData.isError = false;
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleCreateNew = () => {
		window.location.href = "/contextualmedia?page=add";
	};

	const handleManageCategory = () => {
		window.location.href = "/manage-category";
	};

	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	const getColorByStatus = (status: any) => {
		switch (status) {
			case 0:
				return "#FFC300";
			case 1:
				return "#008001";
			case 2:
				return "#FF0000";
			default:
				return "#000000";
		}
	};

	const getConversionStatus = (key: any) => {
		switch (key) {
			case 0:
				return "InProgress";
			case 1:
				return "Completed";
			case 2:
				return "Failed";
			default:
				return "-";
		}
	};

	const handleSort = (sortColumn) => {
		const direction =
			sortColumn === columnSort?.column
				? columnSort?.direction === "desc"
					? "asc"
					: "desc"
				: "desc";
		setColumnSort({ column: sortColumn, direction: direction });
	};
	const handleGetSortColumn = (display, value) => {
		return (
			<div
				className="column-div d-flex"
				onClick={(e) => {
					handleSort(value);
				}}
			>
				{display}
				<img src={updownArrows} alt="updownArrows" />
			</div>
		);
	};

	const handleChnageStatus = (status) => {
		setSelectedStatus(status);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			categoryId: isNaN(status) ? null : parseInt(status),
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(promiseLandAction.promiseLandGetByFilter(body));
	};

	const handleRangeFilter = (data) => {
		setRangeFilter(data);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			categoryId: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			fromOrderNo: data?.from,
			toOrderNo: data?.to,
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(promiseLandAction.promiseLandGetByFilter(body));
	};

	function getEngagementStatus(value: any, mediaType: any): JSX.Element {
		if (mediaType === "image") {
			return (
				<div className="d-flex align-items-center justify-content-center gap-1">
					<span>—</span>
				</div>
			);
		}
		if (value === undefined || value === null) {
			const status = "Unknown";
			const cls = status.toLowerCase();
			return (
				<div className="d-flex align-items-center justify-content-center gap-1">
					<span className={`retention-percent ${cls}`}>—</span>
					<span className={`retention-badge ${cls}`}>N/A</span>
				</div>
			);
		}

		const n = Number(value);
		if (Number.isNaN(n)) {
			const status = "Unknown";
			const cls = status.toLowerCase();
			return (
				<div className="d-flex align-items-center justify-content-center gap-1">
					<span className={`retention-percent ${cls}`}>—</span>
					<span className={`retention-badge ${cls}`}>N/A</span>
				</div>
			);
		}

		const clamped = Math.max(0, Math.min(100, n));
		const rounded = Math.round(clamped);

		let status: "Low" | "Medium" | "High" = "High";

		if (clamped < 30) {
			status = "Low";
		} else if (clamped < 60) {
			status = "Medium";
		} else {
			status = "High";
		}

		const displayPercent = rounded;
		const cls = status.toLowerCase();

		return (
			<div className="d-flex align-items-center justify-content-center gap-1">
				<span className={`retention-percent ${cls}`}>
					{displayPercent !== null ? `${displayPercent}%` : "—"}
				</span>
				<span className={`retention-badge ${cls}`}>{status}</span>
			</div>
		);
	}

	return (
		<div data-testid="promiseLandPage" className="promiseland-list">
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
			</div>
			<div className="card-box">
				<Row className="filter-link-container d-flex gap-1">
					<Col xs="auto">
						<Input
							type="search"
							onChange={(event) => setSearch(event.target.value)}
							className="form-control"
							id="search-filter"
							placeholder="Search here..."
							value={searchText}
						/>
					</Col>
					<Col xs="auto">
						<Select
							id="statusSelect"
							className="status-select"
							placeholder="Select category"
							isClearable
							options={
								categoryList
									? categoryList.map((data: any) => ({
											value: data.categoryId,
											label: data.categoryName,
									  }))
									: []
							}
							onChange={(selected) => {
								if (selected) {
									handleChnageStatus(selected.value);
								} else {
									handleChnageStatus("");
								}
							}}
							styles={{
								container: (base) => ({ ...base }),
								clearIndicator: (base) => ({
									...base,
									cursor: "pointer",
								}),
							}}
						/>
					</Col>
					<Col xs="auto">
						<OrderFilter onApply={handleRangeFilter} />
					</Col>
					<Col xs="auto">
						<Button
							type="submit"
							data-testid="manageCategory"
							color="primary"
							onClick={handleManageCategory}
						>
							Manage Categories
						</Button>
					</Col>
					<Col xs="auto">
						<Button
							id="submit"
							data-testid="createNewPromiseLand"
							className="btn-submit-frm"
							onClick={handleCreateNew}
						>
							Create New
						</Button>
					</Col>
				</Row>
			</div>

			<div className="promiseland-table">
				<table className="table table-hover" data-testid="promiselandTable">
					<thead data-testid="promiselandTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="authorname-th">
								Title
							</th>
							<th scope="col" data-testid="category-th">
								Category
							</th>
							<th scope="col" data-testid="date-th">
								Created Date
							</th>
							<th scope="col" data-testid="conversion-status-th">
								Conversion & Thumbnail Status
							</th>
							<th scope="col" data-testid="total-click-th">
								{handleGetSortColumn("Total Clicks", "TotalClicks")}
							</th>
							<th scope="col" data-testid="unique-click-th">
								{handleGetSortColumn(
									"Unique clicks per user",
									"UniqueUsersClicks"
								)}
							</th>
							<th scope="col" data-testid="order-th">
								{handleGetSortColumn("Retention Rate", "RetentionRatio")}
							</th>
							<th scope="col" data-testid="order-th">
								{handleGetSortColumn("Order No", "SortOrder")}
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="promiselandTableBody">
						{showModal ? (
							<tr>
								<td colSpan={10} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{promiseLandData &&
								promiseLandData?.items?.contextualMedias?.length > 0 ? (
									promiseLandData?.items?.contextualMedias?.map((data: any) => (
										<>
											<tr key={data.mediaItemId}>
												<th scope="row" className="icon-column">
													<a
														href={`/contextualmedia?id=${data?.mediaItemId}`}
														className="detail-link"
														data-testid="promiselandDetailButton"
													>
														<FontAwesomeIcon
															size="2x"
															icon={faEdit}
															title="Details"
															cursor="pointer"
															className="detailButton"
														/>
													</a>
												</th>
												<td id="title">{data?.title} </td>
												<td id="category">{data?.categoryName} </td>
												<td id="publish">
													{new Date(data?.createdAtUtc).toLocaleDateString()}
												</td>
												<td id="conversion-status">
													<span
														style={{
															color: getColorByStatus(data?.hlsStatus),
														}}
													>
														{getConversionStatus(data?.hlsStatus)}
													</span>
												</td>
												<td id="total-clicks" className="text-center">
													{data?.totalClicks}
												</td>
												<td id="unique-clicks" className="text-center">
													{data?.uniqueUsersClicked}
												</td>
												<td id="retention-rate" className="text-center">
													{getEngagementStatus(
														data?.avgRetentionRatio,
														data?.mediaTypeCode
													)}
												</td>
												<td id="order" className="text-center">
													{data?.sortOrder}
												</td>
												<td className="icon-column">
													<FontAwesomeIcon
														size="2x"
														icon={faTrashAlt}
														data-testid="promiselandDeleteButton"
														data-bs-toggle="tooltip"
														cursor="pointer"
														data-bs-placement="bottom"
														title="Delete"
														onClick={() =>
															handleSelectForDelete(data?.mediaItemId)
														}
													/>
												</td>
											</tr>
										</>
									))
								) : (
									<tr>
										<td colSpan={10} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+promiseLandData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							sortDirection: columnSort?.direction ?? "",
							sortColumn: columnSort?.column ?? "",
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch,
							categoryId: isNaN(selectedStatus)
								? null
								: parseInt(selectedStatus),
						};
						setShowModal(true);
						dispatch(promiseLandAction.promiseLandGetByFilter(body));
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete Contextual Media</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteTestimoForm">
						<div
							className="col-form-label"
							data-testid="promiseLandDeleteMessage"
						>
							Deleting this Contextual Media Video will permanently remove. To
							confirm, please click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { promiseLandData, languageData } = state;
	return {
		promiseLandData,
		languageData,
	};
};

export default connect(mapStateToProps)(PromiseLandList);
